// Entorno de RUNTIME para producción stateless.
export const environment = {
  appName: 'Site',
  production: true,

  // URLs fijas: nginx las proxifica hacia los backends reales.
  // Ver nginx-config.yaml → location /proxy/*/
  apiURLs: {
    public:      '/proxy/site',
    private:     '/proxy/site/api',
    publicmito:  '/proxy/mito',
    privatemito: '/proxy/mito/api',
    gioweb3:     '/proxy/gioweb3',
    agenda:      '/proxy/agenda',
    wapp:        '/proxy/wapp',
    deipelogin:  '/proxy/deipelogin',
  },
  gioSocketUrl: '/proxy/socket',

  // Sentry: DSN hardcoded (es público), eventos enviados vía proxy nginx.
  // nginx: location /proxy/sentry/ → https://logapp.deipe.com/
  // La opción `tunnel` en main.ts redirige los eventos al proxy (evita adblockers).
  sentry_dsn:    'https://cae904de99c5e3870ae10fcfd28355e8@logapp.deipe.com/15',
  sentry_tunnel: '/proxy/sentry',
  sentry_enable: true,

  appIds: {
    portalProveedor: '1_v2nyee3gv6swowsokocoock8wcwckscw4so8so8ss0o0c8kso'
  }
};
